import styled from 'styled-components';
import { COLORS } from 'styles/variables';

export const CardWrapper = styled.div`
  position: relative;
  border-radius: 0.8rem;
  border: 1px solid ${COLORS.ROSE_WOOD};
  padding: 2.4rem;
  background-color: white;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 4rem;
`;
